module.exports = __webpack_public_path__ + "img/b3-5.123d202.png";